import React, {CSSProperties} from 'react';
import {Title} from '@treez-ui/core/layout';
import {Button, ButtonClass} from '@treez-ui/core/buttons';

interface Props {
    address?: string;
    imageUrl?: string;
    name: string;
    sellTreezUrl?: string;
}

const titleOverflow: CSSProperties = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const SELL_TREEZ_PRODUCT_MANAGEMENT_ROUTE = '/portalDispensary/portal/ProductManagement';

const StorePreview = (props: Props) => {
    const {address, imageUrl, name, sellTreezUrl} = props;

    const getSellTreezProductManagementURL = () => {
        let baseURL = sellTreezUrl;
        if (sellTreezUrl && sellTreezUrl.charAt(sellTreezUrl.length - 1) == '/') {
            baseURL = sellTreezUrl.substring(0, sellTreezUrl.length - 1);
        }

        return baseURL + SELL_TREEZ_PRODUCT_MANAGEMENT_ROUTE;
    };

    return (
        <div className="image-card">
            <div className="image-container">{imageUrl ? <img src={imageUrl} /> : <div />}</div>
            <div className="content">
                <Title styles={titleOverflow} text={name} />
                {address && <p className="store-address">{address}</p>}
                {sellTreezUrl && (
                    <a
                        target="_blank"
                        href={sellTreezUrl}
                        className="sell-treez-link"
                        rel="noreferrer"
                    >
                        {sellTreezUrl}
                    </a>
                )}
            </div>
            <div className="footer">
                {sellTreezUrl && (
                    <div>
                        <a
                            href={getSellTreezProductManagementURL()}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Button
                                buttonClass={ButtonClass.BASIC}
                                text="Manage Products"
                                onClick={(e) => e.stopPropagation()}
                            />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StorePreview;
